import Vue from 'vue'
import VueTk from '@moke/vue-tk'
import '@moke/vue-tk/dist/vue-tk.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.min.css'
import '../assets/scss/editor.scss'
import Inputs from '../components/inputs'
import FillBox from '../components/fillBox'
import Mixin from '../assets/js/mixin'
import filters from '../assets/js/filter'
import config from '../assets/js/config'
import Pagination from '../components/pagination'
import Callout from '../components/callout'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '../assets/scss/main.scss'
import Viewer from 'v-viewer'
import mSwitch from '../components/mSwitch'
import avatar from '../components/avatar'
import AsyncComputed from 'vue-async-computed'
import 'viewerjs/dist/viewer.css'
import icon from '../assets/json/icon'
import fromNow from '../components/fromNow'
import quotationIcon from '../assets/json/quotation'
import Skeleton from 'vue-loading-skeleton'

Vue.use(Skeleton)
Vue.use(AsyncComputed)
Vue.use(Viewer, { name: 'viewer' })
Vue.use(Vuetify, {
  theme: {
    primary: '#009688',
    secondary: '#26A69A',
    accent: '#009688',
    error: '#F44336',
    warning: '#ffeb3b',
    info: '#2196F3',
    success: '#4CAF50'
  }
})

Vue.prototype.$watchAll = function (props, callback) {
  props.forEach(prop => {
    this.$watch(prop, callback.bind(null, prop))
  })
}

Vue.component('from-now', fromNow)
// Vue.component('v-icon', vIcon)
Vue.component('m-switch', mSwitch)
Vue.component('fill-box', FillBox)
Vue.component('inputs', Inputs)
Vue.component('pagination', Pagination)
Vue.component('callout', Callout)
Vue.component('avatar', avatar)
for (let name in filters) {
  Vue.filter(name, filters[name])
}
Vue.mixin(Mixin)
Vue.use(VueTk)
VueTk.init({
  vue: Vue, // vue示例，tkAjax 的必需项
  icon: { // 图标配置
    custom: { // 自定义图标，参考tkIcon配置项
      default: {
        data: icon
      },
      quotation: {
        data: quotationIcon
      }
    }
  },
  ajax: {
    $apiAjax: { // 可以创建任意名称的ajax示例挂载到vue示例上
      baseURL: config.baseURL
    }
  }
})
